<div class="container-fluid bg-dark min-vh-100">
  <div class="row">
    <div class="col-1 py-3 position-fixed" style="z-index: 10;">
      <div class="min-vh-100 d-flex flex-column align-items-center">
        <div [ngClass]="{ 'btn-disabled': isFullscreen }" (click)="fileTrigger()" role="button"
          class="d-flex align-items-center justify-content-center rounded-circle text-light mb-3 pt-2 btn-rounded-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-upload"
            viewBox="0 0 16 16">
            <path
              d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
            <path
              d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
          </svg>
        </div>
        <div class="custom-file d-none">
          <input (change)="fileChange($event)" multiple accept="image/*" type="file" class="custom-file-input"
            id="duotoneFile">
          <label class="custom-file-label" data-browse="Upload" for="duotoneFile">Choose file</label>
        </div>

        <div (click)="fromColor()" [ngStyle]="{ backgroundColor: duotoneColor.from.hex }"
          class="d-flex align-items-center rounded-circle mb-3 btn-rounded-circle" role="button">
          <input class="form-control bg-transparent border-0 text-light text-center" type="text"
            [value]="duotoneColor.from.hex">
        </div>

        <div (click)="toColor()" [ngStyle]="{ backgroundColor: duotoneColor.to.hex }"
          class="d-flex align-items-center rounded-circle mb-3 btn-rounded-circle" role="button">
          <input class="form-control bg-transparent border-0 text-light text-center" type="text"
            [value]="duotoneColor.to.hex">
        </div>

        <div (click)="duotonePresets()" role="button"
          class="d-flex align-items-center justify-content-center rounded-circle text-light mb-3 btn-rounded-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-droplet-fill"
            viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M8 16a6 6 0 0 0 6-6c0-1.655-1.122-2.904-2.432-4.362C10.254 4.176 8.75 2.503 8 0c0 0-6 5.686-6 10a6 6 0 0 0 6 6zM6.646 4.646c-.376.377-1.272 1.489-2.093 3.13l.894.448c.78-1.559 1.616-2.58 1.907-2.87l-.708-.708z" />
          </svg>
        </div>

        <div (click)="downloads()" role="button"
          class="d-flex align-items-center justify-content-center rounded-circle text-light btn-rounded-circle">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-download"
            viewBox="0 0 16 16">
            <path
              d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
            <path
              d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
          </svg>
        </div>

        <div style="position: fixed; top: 0; right: 0; width: 400px;">
          <div class="input-group p-4">
            <div class="input-group-prepend">
              <span class="input-group-text bg-secondary border-secondary text-light">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search"
                  viewBox="0 0 16 16">
                  <path
                    d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </span>
            </div>
            <input #query (keyup.enter)="search(query.value)" type="text"
              class="form-control bg-dark border-secondary border-right-0 text-light" placeholder="Search unsplash">
            <div (click)="unsplash.results = []; query.value = ''" role="button" class="input-group-append">
              <span class="input-group-text bg-dark border-secondary border-left-0 text-light">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg"
                  viewBox="0 0 16 16">
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
      (scrolled)="search(query.value, unsplash.page)" class="col py-3" style="padding-left: 152px;">
      <div class="d-flex flex-wrap">
        <div (click)="fullscreen(i)" *ngFor="let file of fileList; let i = index" [id]="'duotone-' + i"
          class="svg-container">
          <svg [id]="'svg-duotone-' + i" class="svg-fluid" xmlns:xlink="http://www.w3.org/1999/xlink">
            <filter [id]="'filter-' + i">
              <feColorMatrix type="matrix" [attr.values]="duotoneColor.matrix" color-interpolation-filters="sRGB">
              </feColorMatrix>
            </filter>
            <image width="100%" height="100%" [attr.filter]="'url(#filter-' + i + ')'" [attr.xlink:href]="file.uri"
              x="0" y="0" preserveAspectRatio="xMidYMid slice"></image>
          </svg>

          <div *ngIf="isFullscreen" class="w-100 d-flex align-items-center justify-content-center">
            <button (click)="download($event, i)" type="button"
              class="btn btn-lg btn-outline-light d-flex align-items-center" style="margin-top: -20%;">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                class="bi bi-download mr-2" viewBox="0 0 16 16">
                <path
                  d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                <path
                  d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
              </svg>
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal left fade" tabindex="-1" id="colorPicker">
  <div class="modal-dialog modal-sm">
    <div class="modal-content bg-secondary border-secondary">
      <chrome-picker *ngIf="duotoneColor.type > 0" class="picker w-100" [control]="colorControl"></chrome-picker>

      <div *ngIf="duotoneColor.type == 0" class="d-flex flex-row">
        <div (click)="presetClick(preset)" *ngFor="let preset of duotoneColor.presets" class="d-flex flex-column p-2"
          role="button">
          <div [ngStyle]="{ backgroundColor: preset.from.hex }" class="rounded-circle m-1 btn-color"></div>
          <div [ngStyle]="{ backgroundColor: preset.to.hex }" class="rounded-circle m-1 btn-color"></div>
        </div>
      </div>
    </div>
  </div>
</div>
